import React, { useEffect, useState } from 'react'
import { Link, useLocation } from "react-router-dom";
import "./adminSidebar.css";
import { adminSidebarItems } from "../../utils/data";

const AdminSidebar = () => {

    const [activeLink, setActiveLink] = useState("");

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setActiveLink(path);
    sessionStorage.getItem("aussivo_token");
  }, [location]);

  const isActive = (path) => {
    return window.location.pathname === path ? "active-link" : "";
  };

  return (
    <aside className="admin_sidebar_warp">
      {adminSidebarItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
           className={`adminsidebar_link ${isActive(item.path)}`}
        >
          <img src={item.icon} alt={item.label} className="adminsidebar_icon" />
          <span className="adminsidebar_txt">{item.label}</span>
        </Link>
      ))}
    </aside>
  )
}

export default AdminSidebar